var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2335 11.3832C27.0625 11.5159 24.0437 13.2169 24.0437 16.9992C24.0437 21.3741 27.885 22.9218 28 22.9602C27.9823 23.0545 27.3898 25.0798 25.9747 27.1434C24.7129 28.9594 23.3952 30.7725 21.3905 30.7725C19.3858 30.7725 18.8699 29.608 16.5557 29.608C14.3005 29.608 13.4986 30.8108 11.6649 30.8108C9.83122 30.8108 8.55177 29.1304 7.0807 27.0668C5.37674 24.6435 4 20.8789 4 17.3058C4 11.5748 7.72632 8.53541 11.3937 8.53541C13.3423 8.53541 14.9667 9.81486 16.1901 9.81486C17.3546 9.81486 19.1706 8.45876 21.3875 8.45876C22.2277 8.45876 25.2465 8.53541 27.2335 11.3832ZM20.3351 6.03252C21.2519 4.94469 21.9005 3.4353 21.9005 1.9259C21.9005 1.71659 21.8828 1.50433 21.8445 1.33334C20.3528 1.38936 18.5781 2.32683 17.5079 3.56796C16.6677 4.52312 15.8836 6.03252 15.8836 7.56255C15.8836 7.7925 15.9219 8.02245 15.9396 8.09615C16.0339 8.11384 16.1872 8.13447 16.3405 8.13447C17.6789 8.13447 19.3622 7.23827 20.3351 6.03252Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.843ca9d648e5c4966fc66dbff4c92be5.svg";
export { ForwardRef as ReactComponent };